// @flow

import { selectFeatureFlag } from '@gandi/authentication';

import LoginRowNDS from 'src/DomainRenew/componentsNDS/LoginRow';
import { useAppSelector } from 'src/hooks';

import LoginRowLegacy from './LoginRow';

export function LoginRowSwitch(): React.MixedElement {
  const FF_TRANSFERT_NDS = useAppSelector(state =>
    selectFeatureFlag(state, {
      featureFlagName: 'FF_TRANSFERT_NDS',
    }),
  );

  return FF_TRANSFERT_NDS ? <LoginRowNDS /> : <LoginRowLegacy />;
}
